(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2560],{

/***/ 97298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_NavbarFloating; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/focus-trap-react@8.11.3_xw2k5ke7c4fkuho3lbp7joprty/node_modules/focus-trap-react/dist/focus-trap-react.js
var focus_trap_react = __webpack_require__(29876);
var focus_trap_react_default = /*#__PURE__*/__webpack_require__.n(focus_trap_react);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/router.js
var next_router = __webpack_require__(86317);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hydration-on-demand@2.1.0_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-hydration-on-demand/dist/index.js
var dist = __webpack_require__(94531);
// EXTERNAL MODULE: ./components/index.ts + 27 modules
var components = __webpack_require__(94842);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./components/global/Icon/index.tsx + 1 modules
var Icon = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/global/Link/index.tsx + 1 modules
var Link = __webpack_require__(84381);
// EXTERNAL MODULE: ./components/global/Toast/index.tsx + 16 modules
var Toast = __webpack_require__(81530);
// EXTERNAL MODULE: ./components/providers/RegionsProvider.tsx + 10 modules
var RegionsProvider = __webpack_require__(60239);
// EXTERNAL MODULE: ./components/providers/TypefaceProvider.tsx
var TypefaceProvider = __webpack_require__(49717);
// EXTERNAL MODULE: ./lib/hooks/useUser.ts
var useUser = __webpack_require__(56804);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./saleor/api.tsx + 4 modules
var api = __webpack_require__(67062);
// EXTERNAL MODULE: ./components/global/NavbarFloating/NavbarFloating.module.scss
var NavbarFloating_module = __webpack_require__(7109);
var NavbarFloating_module_default = /*#__PURE__*/__webpack_require__.n(NavbarFloating_module);
;// CONCATENATED MODULE: ./components/global/NavbarFloating/NavbarFloating.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


















var focusTrapWatcher = function(param) {
    var _param = _slicedToArray(param, 1), container = _param[0];
    return new Promise(function(resolve) {
        return setTimeout(function() {
            return resolve();
        }, 400);
    });
};
var loopThroughParents = function(el, check) {
    check(el);
    if (el.parentElement) loopThroughParents(el.parentElement, check);
};
var NavLink = function(param) {
    var link = param.link, current = param.current, closeMenu = param.closeMenu;
    return link === current ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        onClick: closeMenu,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).currentLink, "u-h5"),
            children: link.text
        })
    }, link.text) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: link.href,
            label: link.text,
            className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).link, "u-h5")
        })
    }, link.text);
};
var AddTypefaceToCartWithHydrationOnDemand = (0,dist/* default */.Z)({
    on: [
        "visible"
    ]
})(components/* AddTypefaceToCart */.TV);
var NavbarFloating = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _links = param.links, links = _links === void 0 ? [] : _links, product = param.product, productLicences = param.productLicences;
    var paths = (0,lib_paths/* usePaths */._)();
    var query = (0,RegionsProvider/* useRegions */.eH)().query;
    var authenticated = (0,useUser/* useUser */.a)().authenticated;
    var ref = (0,react.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    // Get product variant data
    var ref1 = (0,api/* useProductBySlugQuery */.fW$)({
        variables: {
            slug: product.slug,
            locale: query.locale,
            channel: "uk-store"
        }
    }), loading = ref1.loading, error = ref1.error, data = ref1.data;
    var ref2 = (0,TypefaceProvider/* useTypefaceAddToCart */.d8)(), setConfiguratorVisible = ref2.setIsOpen, resetState = ref2.resetState, typefaceState = ref2.state;
    var configuratorVisible = typefaceState.isOpen, isAddedToCart = typefaceState.isAddedToCart;
    var ref3 = (0,react.useState)(false), navMenuOpen = ref3[0], setNavMenuOpen = ref3[1];
    var closeMenu = function() {
        return setNavMenuOpen(false);
    };
    var openConfigurator = function() {
        return setConfiguratorVisible(true);
    };
    var closeConfigurator = function() {
        return setConfiguratorVisible(false);
    };
    var router = (0,next_router.useRouter)();
    var typefaceRoot = router.asPath.split("/").slice(0, 3).join("/");
    var overviewSection = {
        href: typefaceRoot,
        text: "Overview"
    };
    var getSection = function() {
        var path = router.pathname.split("[slug]")[1].split("/")[1];
        var href = (path ? path : "Overview").replace("/", "");
        var current = links.find(function(link) {
            return link.href.includes(href);
        });
        if (current) return current;
        return overviewSection;
    };
    var typefaceSection = getSection();
    var focusTrapOptions = {
        checkCanFocusTrap: focusTrapWatcher,
        allowOutsideClick: true
    };
    (0,react.useEffect)(function() {
        if (!navMenuOpen) return;
        var clickListen = function(ev) {
            if (!navMenuOpen) return;
            var isNavMenuClick = false;
            loopThroughParents(ev.target, function(el) {
                if (el.className === (NavbarFloating_module_default()).container) isNavMenuClick = true;
            });
            if (!isNavMenuClick) setNavMenuOpen(false);
        };
        window.addEventListener("click", clickListen);
        document.addEventListener("touchstart", clickListen);
        return function() {
            window.removeEventListener("click", clickListen);
            document.removeEventListener("touchstart", clickListen);
        };
    }, [
        navMenuOpen
    ]);
    var successToastAction = function() {
        var checkout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        closeConfigurator();
        resetState();
        document.body.classList.remove("ReactModal__Body--open");
        if (checkout) {
            router.push(paths.cart.$url());
        }
    };
    // Fix hydration error 2-pass rendering
    (0,react.useEffect)(function() {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isAddedToCart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* SuccessToast */.bF, {
                successToastAction: successToastAction
            }),
            (data === null || data === void 0 ? void 0 : data.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTypefaceToCartWithHydrationOnDemand, {
                product: data.product,
                setClosed: closeConfigurator,
                productLicences: productLicences,
                isOpen: configuratorVisible
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).container, className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NavbarFloating_module_default()).inner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((focus_trap_react_default()), {
                            active: navMenuOpen,
                            focusTrapOptions: focusTrapOptions,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).navMenu, navMenuOpen && (NavbarFloating_module_default()).navMenu__open),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "ghost",
                                        type: "button",
                                        size: "l",
                                        className: (NavbarFloating_module_default()).close,
                                        callBack: closeMenu,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            iconName: "close",
                                            width: "24",
                                            height: "24"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                        className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).controls__button, (NavbarFloating_module_default()).menuBuy),
                                        type: "button",
                                        size: "l",
                                        callBack: function() {
                                            return openConfigurator();
                                        },
                                        dynamicSize: false,
                                        children: [
                                            "Buy ",
                                            product.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                                link: overviewSection,
                                                current: typefaceSection,
                                                closeMenu: closeMenu
                                            }),
                                            links.map(function(link) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                                                    link: link,
                                                    current: typefaceSection,
                                                    closeMenu: closeMenu
                                                }, link.text);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], _objectSpread({
                                                    href: "/account".concat(!authenticated ? "/login" : "")
                                                }, authenticated && {
                                                    as: "/account/trials?font=".concat(product.id)
                                                }, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).link, "u-h5"),
                                                        children: "Trials"
                                                    })
                                                }))
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).controls, navMenuOpen && (NavbarFloating_module_default()).controls__open),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).controls__button, (NavbarFloating_module_default()).navigate),
                                    type: "button",
                                    variant: "secondary",
                                    size: "l",
                                    dynamicSize: false,
                                    callBack: function() {
                                        return setNavMenuOpen(true);
                                    },
                                    children: typefaceSection === null || typefaceSection === void 0 ? void 0 : typefaceSection.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)((NavbarFloating_module_default()).controls__button, (NavbarFloating_module_default()).buy),
                                    type: "button",
                                    size: "l",
                                    dynamicSize: false,
                                    callBack: function() {
                                        return openConfigurator();
                                    },
                                    children: [
                                        "Buy ",
                                        product.name
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var NavbarFloating_NavbarFloating = (NavbarFloating);

;// CONCATENATED MODULE: ./components/global/NavbarFloating/index.tsx

/* harmony default export */ var global_NavbarFloating = (NavbarFloating_NavbarFloating);


/***/ }),

/***/ 14782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_PageTheme; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./components/global/PageTheme/PageTheme.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var PageTheme = function(param) {
    var themeBlok = param.themeBlok;
    if (!themeBlok || themeBlok.length !== 1) return;
    var _themeBlok = _slicedToArray(themeBlok, 1), ref = _themeBlok[0], colorPrimaryPreset = ref.colorPrimaryPreset, colorPrimary = ref.colorPrimary, colorBackgroundPreset = ref.colorBackgroundPreset, colorBackground = ref.colorBackground, variant = ref.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
        dangerouslySetInnerHTML: {
            __html: ":root { \n            --page-theme-primary: ".concat(colorPrimary || colorPrimaryPreset, ";\n            --page-theme-background: ").concat(colorBackground || colorBackgroundPreset || "var(--".concat(variant, ")"), ";\n          }")
        }
    });
};
/* harmony default export */ var PageTheme_PageTheme = (PageTheme);

;// CONCATENATED MODULE: ./components/global/PageTheme/index.tsx

/* harmony default export */ var global_PageTheme = (PageTheme_PageTheme);


/***/ }),

/***/ 57758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BaseSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59370);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52375);



var trimTrailingSlash = function(slug) {
    return slug[slug.length - 1] === "/" ? slug.slice(0, slug.length - 1) : slug;
};
var BaseSeo = function(param) {
    var title = param.title, ogTitle = param.ogTitle, description = param.description, ogDescription = param.ogDescription, path = param.path, image = param.image;
    var canonical = path ? "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(trimTrailingSlash(path)) : _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O;
    var baseTitle = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_NAME */ .px;
    var baseDescription = "Colophon is an international, award-winning type foundry based in London (UK) and Los Angeles (US). We create, publish, and distribute high-quality retail and custom typefaces for analog and digital media.";
    var seoTitle = title || baseTitle;
    var seoDescription = description || baseDescription;
    var twitter = _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1 ? {
        handle: _lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SOCIAL_TWITTER_ID */ .R1,
        cardType: "summary_large_image"
    } : null;
    var openGraph = {
        url: canonical,
        title: ogTitle || seoTitle,
        description: ogDescription || seoDescription,
        images: [
            {
                url: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_2__/* .SITE_URL */ ._O).concat(image ? image : "/img/og.png"),
                alt: "Colophon Foundry"
            }
        ],
        site_name: "Colophon Foundry"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seoTitle,
        description: seoDescription,
        canonical: canonical,
        twitter: twitter,
        openGraph: openGraph
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseSeo);


/***/ }),

/***/ 47659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Storyblok; },
  "P": function() { return /* reexport */ useStoryblok; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
;// CONCATENATED MODULE: ./storyblok/hooks/useStoryblok.ts


function useStoryblok(originalStory, preview) {
    var resolve_relations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var initEventListeners = // adds the events for updating the visual editor
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#initializing-the-storyblok-js-bridge
    function initEventListeners() {
        var StoryblokBridge = window.StoryblokBridge;
        if (typeof StoryblokBridge !== "undefined") {
            // initialize the bridge with your token
            var storyblokInstance = new StoryblokBridge({
                resolveRelations: resolve_relations
            });
            // reload on Next.js page on save or publish event in the Visual Editor
            storyblokInstance.on([
                "change",
                "published"
            ], function() {
                return location.reload();
            });
            // live update the story on input events
            storyblokInstance.on("input", function(event) {
                // check if the ids of the event and the passed story match
                if (story && event.story.content._uid === story.content._uid) {
                    // change the story content through the setStory function
                    setStory(event.story);
                }
            });
            storyblokInstance.on("enterEditmode", function(event) {
                // loading the draft version on initial enter of editor
                Storyblok.get("cdn/stories/".concat(event.storyId), {
                    resolve_relations: resolve_relations,
                    version: "draft"
                }).then(function(param) {
                    var data = param.data;
                    if (data.story) {
                        setStory(data.story);
                    }
                }).catch(function(error) {
                    console.log(error);
                });
            });
        }
    };
    var addBridge = // appends the bridge script tag to our document
    // see https://www.storyblok.com/docs/guide/essentials/visual-editor#installing-the-storyblok-js-bridge
    function addBridge(callback) {
        // check if the script is already present
        var existingScript = document.getElementById("storyblokBridge");
        if (!existingScript) {
            var script = document.createElement("script");
            script.src = "//app.storyblok.com/f/storyblok-v2-latest.js";
            script.id = "storyblokBridge";
            document.body.appendChild(script);
            script.onload = function() {
                // once the scrip is loaded, init the event listeners
                callback();
            };
        } else {
            callback();
        }
    };
    var ref = (0,react.useState)(originalStory), story = ref[0], setStory = ref[1];
    (0,react.useEffect)(function() {
        // only load inside preview mode
        if (preview) {
            // first load the bridge, then initialize the event listeners
            addBridge(initEventListeners);
        }
    }, [
        originalStory,
        preview,
        setStory
    ]); // runs the effect only once & defines effect dependencies
    return story;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/storyblok-js-client@4.5.6_axios@0.21.4/node_modules/storyblok-js-client/dist/index.es.js
var index_es = __webpack_require__(78578);
;// CONCATENATED MODULE: ./storyblok/lib/storyblok.js

var STORYBOOK_API_KEY = "WygMRPInxMCOSMUw1Vt4TAtt";
var Storyblok = new index_es/* default */.Z({
    accessToken: STORYBOOK_API_KEY,
    cache: {
        clear: "auto",
        type: "memory"
    }
});

;// CONCATENATED MODULE: ./storyblok/index.ts




/***/ }),

/***/ 7109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NavbarFloating_container__NsZim","controls":"NavbarFloating_controls__s2YZu","navigate":"NavbarFloating_navigate__lU5EZ","buy":"NavbarFloating_buy__rNFiU","controls__open":"NavbarFloating_controls__open___sgCD","navMenu":"NavbarFloating_navMenu__16qLv","navMenu__open":"NavbarFloating_navMenu__open__yLQYi","link":"NavbarFloating_link__9Km62","currentLink":"NavbarFloating_currentLink__s7jWv","close":"NavbarFloating_close__2WVmT","menuBuy":"NavbarFloating_menuBuy__ioWOi","toastMessage":"NavbarFloating_toastMessage__na_Vx","hidden":"NavbarFloating_hidden__VLtyG","inner":"NavbarFloating_inner__CcHm_"};

/***/ })

}]);